import { type } from "../types/types";

export const set_returns = (returns) => (dispatch) => {
  dispatch({
    type: type.SET_RETURNS,
    returns: returns,
  });
};

export const set_return_detail = (returnDetail) => (dispatch) => {
  dispatch({
    type: type.SET_RETURN_DETAIL,
    returnDetail: returnDetail,
  });
};
